import { render, staticRenderFns } from "./ProcessChargesStops.vue?vue&type=template&id=97cff2f4&scoped=true&"
import script from "./ProcessChargesStops.vue?vue&type=script&lang=js&"
export * from "./ProcessChargesStops.vue?vue&type=script&lang=js&"
import style0 from "./ProcessChargesStops.vue?vue&type=style&index=0&id=97cff2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cff2f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97cff2f4')) {
      api.createRecord('97cff2f4', component.options)
    } else {
      api.reload('97cff2f4', component.options)
    }
    module.hot.accept("./ProcessChargesStops.vue?vue&type=template&id=97cff2f4&scoped=true&", function () {
      api.rerender('97cff2f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessCharges/ProcessChargesStops.vue"
export default component.exports